import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { tPackageService } from 'src/app/services/tPackage.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { tPackageModel } from 'src/app/models/tPackageModel';

@Component({
  selector: 'app-package-dialog',
  templateUrl: './package-dialog.component.html',
  styleUrls: ['./package-dialog.component.css']
})
export class PackageDialogComponent implements OnInit {

  //form
  bntStyle: string;
  submitted = false;
  editForm: FormGroup;

  TAG = "PackageDialogComponent";

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private formBuilder: FormBuilder,
    private apiResultHandlerService: ApiResultHandlerService,
    private tPackageService: tPackageService
  ) { }

  displayedColumns: string[] = [

    // 'shopID',

    'packID',
    'packDescAll',
    'packItemID',
    'packFaceAmt',
    'packRcdAmt',
    'packDisc',

    // 'lastModifyDatetime',
    // 'lastModifyUserID',
    // 'isActive'

  ];

  dataSource: MatTableDataSource<tPackageModel>;
  dataList: tPackageModel[];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    this.bntStyle = 'btn-default';
    this.getAllData();
  }

  getAllData(): void {
    this.log.i(this.TAG, 'getAllData = ');
    // this.getItemTypeInfo();

    this.tPackageService.getAllData().subscribe(data => {

      this.dataList = data;
      this.dataSource = new MatTableDataSource<tPackageModel>(this.dataList);
 
    });
  }



  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }
}
